import useContainer from '@admin/hooks/use_container'

import automationAccessConfig from '@apps/automation/config/access.js'
import calendarAccessConfig from '@apps/calendar/config/access.js'
import campaignsAccessConfig from '@apps/campaigns/config/access.js'
import crmAccessConfig from '@apps/crm/config/access.js'
import dashboardsAccessConfig from '@apps/dashboards/config/access.js'
import domainsAccessConfig from '@apps/domains/config/access.js'
import financeAccessConfig from '@apps/finance/config/access.js'
import formsAccessConfig from '@apps/forms/config/access.js'
import mahaAccessConfig from '@apps/maha/config/access.js'
import phoneAccessConfig from '@apps/phone/config/access.js'
import platformAccessConfig from '@apps/platform/config/access.js'
import subscriptionsAccessConfig from '@apps/subscriptions/config/access.js'
import teamAccessConfig from '@apps/team/config/access.js'
import truevailAccessConfig from '@apps/truevail/config/access.js'
import automationRoutes from '@apps/automation/admin/views/index.js'
import calendarRoutes from '@apps/calendar/admin/views/index.js'
import campaignsRoutes from '@apps/campaigns/admin/views/index.js'
import crmRoutes from '@apps/crm/admin/views/index.js'
import dashboardsRoutes from '@apps/dashboards/admin/views/index.js'
import domainsRoutes from '@apps/domains/admin/views/index.js'
import financeRoutes from '@apps/finance/admin/views/index.js'
import formsRoutes from '@apps/forms/admin/views/index.js'
import mahaRoutes from '@apps/maha/admin/views/index.js'
import phoneRoutes from '@apps/phone/admin/views/index.js'
import platformRoutes from '@apps/platform/admin/views/index.js'
import subscriptionsRoutes from '@apps/subscriptions/admin/views/index.js'
import teamRoutes from '@apps/team/admin/views/index.js'
import truevailRoutes from '@apps/truevail/admin/views/index.js'
import calendarBadges from '@apps/calendar/admin/badges/index.js'
import crmBadges from '@apps/crm/admin/badges/index.js'
import mahaBadges from '@apps/maha/admin/badges/index.js'
import phoneBadges from '@apps/phone/admin/badges/index.js'
import platformBadges from '@apps/platform/admin/badges/index.js'
import truevailBadges from '@apps/truevail/admin/badges/index.js'
import automationTriggers from '@apps/automation/config/triggers.js'
import calendarTriggers from '@apps/calendar/config/triggers.js'
import campaignsTriggers from '@apps/campaigns/config/triggers.js'
import crmTriggers from '@apps/crm/config/triggers.js'
import dashboardsTriggers from '@apps/dashboards/config/triggers.js'
import domainsTriggers from '@apps/domains/config/triggers.js'
import financeTriggers from '@apps/finance/config/triggers.js'
import formsTriggers from '@apps/forms/config/triggers.js'
import mahaTriggers from '@apps/maha/config/triggers.js'
import phoneTriggers from '@apps/phone/config/triggers.js'
import platformTriggers from '@apps/platform/config/triggers.js'
import subscriptionsTriggers from '@apps/subscriptions/config/triggers.js'
import teamTriggers from '@apps/team/config/triggers.js'
import truevailTriggers from '@apps/truevail/config/triggers.js'
import mahaRoots from '@apps/maha/admin/roots/index.js'
import phoneRoots from '@apps/phone/admin/roots/index.js'
import truevailRoots from '@apps/truevail/admin/roots/index.js'
import financeUserTasks from '@apps/finance/admin/hooks/user_tasks.js'
import financeUserFields from '@apps/finance/admin/hooks/user_fields.js'
import financeUserValues from '@apps/finance/admin/hooks/user_values.js'
import automationActivityCards from '@apps/automation/integrations/crm/activities/index.js'
import campaignsActivityCards from '@apps/campaigns/integrations/crm/activities/index.js'
import crmActivityCards from '@apps/crm/integrations/crm/activities/index.js'
import formsActivityCards from '@apps/forms/integrations/crm/activities/index.js'
import phoneActivityCards from '@apps/phone/integrations/crm/activities/index.js'
import truevailActivityCards from '@apps/truevail/integrations/crm/activities/index.js'
import AutomationconfigcalendarJs from '@apps/automation/config/calendar.js'
import CalendarconfigcalendarJs from '@apps/calendar/config/calendar.js'
import CampaignsconfigcalendarJs from '@apps/campaigns/config/calendar.js'
import CrmconfigcalendarJs from '@apps/crm/config/calendar.js'
import DashboardsconfigcalendarJs from '@apps/dashboards/config/calendar.js'
import DomainsconfigcalendarJs from '@apps/domains/config/calendar.js'
import FinanceconfigcalendarJs from '@apps/finance/config/calendar.js'
import FormsconfigcalendarJs from '@apps/forms/config/calendar.js'
import MahaconfigcalendarJs from '@apps/maha/config/calendar.js'
import PhoneconfigcalendarJs from '@apps/phone/config/calendar.js'
import PlatformconfigcalendarJs from '@apps/platform/config/calendar.js'
import SubscriptionsconfigcalendarJs from '@apps/subscriptions/config/calendar.js'
import TeamconfigcalendarJs from '@apps/team/config/calendar.js'
import TruevailconfigcalendarJs from '@apps/truevail/config/calendar.js'
import CampaignsintegrationscalendaremailCampaignsScheduledviewsindexJs from '@apps/campaigns/integrations/calendar/email_campaigns_scheduled/views/index.js'
import CampaignsintegrationscalendaremailCampaignsSentviewsindexJs from '@apps/campaigns/integrations/calendar/email_campaigns_sent/views/index.js'
import CampaignsintegrationscalendarsocialCampaignsPostedviewsindexJs from '@apps/campaigns/integrations/calendar/social_campaigns_posted/views/index.js'
import CampaignsintegrationscalendarsocialCampaignsScheduledviewsindexJs from '@apps/campaigns/integrations/calendar/social_campaigns_scheduled/views/index.js'
import TruevailintegrationscalendaremailCampaignsScheduledviewsindexJs from '@apps/truevail/integrations/calendar/email_campaigns_scheduled/views/index.js'
import TruevailintegrationscalendaremailCampaignsSentviewsindexJs from '@apps/truevail/integrations/calendar/email_campaigns_sent/views/index.js'
import CampaignsintegrationsdashboardsemailCampaignMetricviewsindexJs from '@apps/campaigns/integrations/dashboards/email_campaign_metric/views/index.js'
import CampaignsintegrationsdashboardssocialCampaignMetricviewsindexJs from '@apps/campaigns/integrations/dashboards/social_campaign_metric/views/index.js'
import CrmintegrationsdashboardsnewContactsviewsindexJs from '@apps/crm/integrations/dashboards/new_contacts/views/index.js'
import CrmintegrationsdashboardsprogramRevenueviewsindexJs from '@apps/crm/integrations/dashboards/program_revenue/views/index.js'
import CrmintegrationsdashboardssubscriptionsviewsindexJs from '@apps/crm/integrations/dashboards/subscriptions/views/index.js'
import FormsintegrationsdashboardsresponsesviewsindexJs from '@apps/forms/integrations/dashboards/responses/views/index.js'
import FormsintegrationsdashboardsrevenueviewsindexJs from '@apps/forms/integrations/dashboards/revenue/views/index.js'
import MahaintegrationsdashboardsaffiliateAnnualRecurringRevenueviewsindexJs from '@apps/maha/integrations/dashboards/affiliate_annual_recurring_revenue/views/index.js'
import MahaintegrationsdashboardsaffiliateCancellationsviewsindexJs from '@apps/maha/integrations/dashboards/affiliate_cancellations/views/index.js'
import MahaintegrationsdashboardsaffiliateLifetimeRevenueviewsindexJs from '@apps/maha/integrations/dashboards/affiliate_lifetime_revenue/views/index.js'
import MahaintegrationsdashboardsaffiliateMonthlyRecurringRevenueviewsindexJs from '@apps/maha/integrations/dashboards/affiliate_monthly_recurring_revenue/views/index.js'
import MahaintegrationsdashboardsaffiliateSignupsviewsindexJs from '@apps/maha/integrations/dashboards/affiliate_signups/views/index.js'
import MahaintegrationsdashboardsaffiliateSubscriptionsviewsindexJs from '@apps/maha/integrations/dashboards/affiliate_subscriptions/views/index.js'
import MahaintegrationsdashboardsaffiliatesviewsindexJs from '@apps/maha/integrations/dashboards/affiliates/views/index.js'
import MahaintegrationsdashboardsgreetingviewsindexJs from '@apps/maha/integrations/dashboards/greeting/views/index.js'
import SubscriptionsintegrationsdashboardsannualRecurringRevenueviewsindexJs from '@apps/subscriptions/integrations/dashboards/annual_recurring_revenue/views/index.js'
import SubscriptionsintegrationsdashboardscancellationsviewsindexJs from '@apps/subscriptions/integrations/dashboards/cancellations/views/index.js'
import SubscriptionsintegrationsdashboardsmonthlyRecurringRevenueviewsindexJs from '@apps/subscriptions/integrations/dashboards/monthly_recurring_revenue/views/index.js'
import SubscriptionsintegrationsdashboardssubscriptionsviewsindexJs from '@apps/subscriptions/integrations/dashboards/subscriptions/views/index.js'
import TruevailintegrationsdashboardsadvisorStartviewsindexJs from '@apps/truevail/integrations/dashboards/advisor_start/views/index.js'
import TruevailintegrationsdashboardsaggregateEmailCampaignMetricviewsindexJs from '@apps/truevail/integrations/dashboards/aggregate_email_campaign_metric/views/index.js'
import TruevailintegrationsdashboardsaggregateSocialCampaignMetricviewsindexJs from '@apps/truevail/integrations/dashboards/aggregate_social_campaign_metric/views/index.js'
import TruevailintegrationsdashboardsrenewalPaymentsviewsindexJs from '@apps/truevail/integrations/dashboards/renewal_payments/views/index.js'
import TruevailintegrationsdashboardssignupsviewsindexJs from '@apps/truevail/integrations/dashboards/signups/views/index.js'
import TruevailintegrationsdashboardsstatusesviewsindexJs from '@apps/truevail/integrations/dashboards/statuses/views/index.js'
import TruevailintegrationsdashboardstransitionDurationsviewsindexJs from '@apps/truevail/integrations/dashboards/transition_durations/views/index.js'
import crmSettings from '@apps/crm/admin/hooks/settings.js'
import financeSettings from '@apps/finance/admin/hooks/settings.js'
import teamSettings from '@apps/team/admin/hooks/settings.js'
import LocalStorage from '@admin/components/local_storage'
import Forbidden from '@apps/maha/admin/views/forbidden'
import NotFound from '@apps/maha/admin/views/not_found'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import Analytics from '@admin/components/analytics'
import Locale from '@admin/components/locale'
import Provider from '@admin/components/provider'
import Platform from '@admin/components/platform'
import Revision from '@admin/components/revision'
import Network from '@admin/components/network'
import Sentry from '@admin/components/sentry'
import Logger from '@admin/components/logger'
import Device from '@admin/components/device'
import Flash from '@admin/components/flash'
import Admin from '@admin/components/admin'
import Host from '@admin/components/host'
import Maha from '@admin/components/maha'
import { DndProvider } from 'react-dnd'
import { hot } from 'react-hot-loader'
import PropTypes from 'prop-types'
import React from 'react'
import './index.scss'

class App extends React.Component {

  render() {
    return (
      <Platform>
        <Sentry>
          <DndProvider backend={ this._getBackend() }>
            <Logger>
              <Maha { ...this._getMaha() }>
                <Network>
                  <LocalStorage>
                    <Locale>
                      <Provider>
                        <Device>
                          <Revision>
                            <Analytics>
                              <Host>
                                <Flash>
                                  <Admin />
                                </Flash>
                              </Host>
                            </Analytics>
                          </Revision>
                        </Device>
                      </Provider>
                    </Locale>
                  </LocalStorage>
                </Network>
              </Maha>
            </Logger>
          </DndProvider>
        </Sentry>
      </Platform>
    )
  }

  _getAccess() {
    return [
      { title: 'Automation',  code: 'automation', ...automationAccessConfig },
      { title: 'Calendar',  code: 'calendar', ...calendarAccessConfig },
      { title: 'Campaigns',  code: 'campaigns', ...campaignsAccessConfig },
      { title: 'CRM',  code: 'crm', ...crmAccessConfig },
      { title: 'Dashboards',  code: 'dashboards', ...dashboardsAccessConfig },
      { title: 'Domains',  code: 'domains', ...domainsAccessConfig },
      { title: 'Finance',  code: 'finance', ...financeAccessConfig },
      { title: 'Forms',  code: 'forms', ...formsAccessConfig },
      { title: 'Maha',  code: 'maha', ...mahaAccessConfig },
      { title: 'Phone',  code: 'phone', ...phoneAccessConfig },
      { title: 'Platform',  code: 'platform', ...platformAccessConfig },
      { title: 'Subscriptions',  code: 'subscriptions', ...subscriptionsAccessConfig },
      { title: 'Team',  code: 'team', ...teamAccessConfig },
      { title: 'Truevail',  code: 'truevail', ...truevailAccessConfig },
    ]
  }

  _getActivityCards() {
    return {
      ...automationActivityCards,
      ...campaignsActivityCards,
      ...crmActivityCards,
      ...formsActivityCards,
      ...phoneActivityCards,
      ...truevailActivityCards,
    }
  }

  _getAppUserFields() {
    return [
      { app: 'finance', fields: financeUserFields },
    ]
  }

  _getAppUserTasks() {
    return [
      financeUserTasks,
    ]
  }

  _getAppUserValues() {
    return [
      { app: 'finance', sections: financeUserValues },
    ]
  }

  _getBackend() {
    if(typeof window !== undefined ) return HTML5Backend
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    return isTouchDevice ? TouchBackend : HTML5Backend
  }

  _getBadges() {
    return [
      ...calendarBadges.map(badge => ({
        app: 'calendar',
        ...badge
      })),
      ...crmBadges.map(badge => ({
        app: 'crm',
        ...badge
      })),
      ...mahaBadges.map(badge => ({
        app: 'maha',
        ...badge
      })),
      ...phoneBadges.map(badge => ({
        app: 'phone',
        ...badge
      })),
      ...platformBadges.map(badge => ({
        app: 'platform',
        ...badge
      })),
      ...truevailBadges.map(badge => ({
        app: 'truevail',
        ...badge
      })),
    ]
  }

  _getCalendarTypes() {
    return [
      ...AutomationconfigcalendarJs.map(calendar => ({
        app: 'automation',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...CalendarconfigcalendarJs.map(calendar => ({
        app: 'calendar',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...CampaignsconfigcalendarJs.map(calendar => ({
        app: 'campaigns',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...CrmconfigcalendarJs.map(calendar => ({
        app: 'crm',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...DashboardsconfigcalendarJs.map(calendar => ({
        app: 'dashboards',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...DomainsconfigcalendarJs.map(calendar => ({
        app: 'domains',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...FinanceconfigcalendarJs.map(calendar => ({
        app: 'finance',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...FormsconfigcalendarJs.map(calendar => ({
        app: 'forms',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...MahaconfigcalendarJs.map(calendar => ({
        app: 'maha',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...PhoneconfigcalendarJs.map(calendar => ({
        app: 'phone',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...PlatformconfigcalendarJs.map(calendar => ({
        app: 'platform',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...SubscriptionsconfigcalendarJs.map(calendar => ({
        app: 'subscriptions',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...TeamconfigcalendarJs.map(calendar => ({
        app: 'team',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
      ...TruevailconfigcalendarJs.map(calendar => ({
        app: 'truevail',
        code: calendar.code,
        entity: calendar.entity,
        action: calendar.action,
        route: calendar.route
      })),
    ]
  }

  _getDashboardCards() {
    return [
      {
        ...CampaignsintegrationsdashboardsemailCampaignMetricviewsindexJs,
        app: 'campaigns',
        type: CampaignsintegrationsdashboardsemailCampaignMetricviewsindexJs.code,
        code: 'campaigns:'+CampaignsintegrationsdashboardsemailCampaignMetricviewsindexJs.code
      },
      {
        ...CampaignsintegrationsdashboardssocialCampaignMetricviewsindexJs,
        app: 'campaigns',
        type: CampaignsintegrationsdashboardssocialCampaignMetricviewsindexJs.code,
        code: 'campaigns:'+CampaignsintegrationsdashboardssocialCampaignMetricviewsindexJs.code
      },
      {
        ...CrmintegrationsdashboardsnewContactsviewsindexJs,
        app: 'crm',
        type: CrmintegrationsdashboardsnewContactsviewsindexJs.code,
        code: 'crm:'+CrmintegrationsdashboardsnewContactsviewsindexJs.code
      },
      {
        ...CrmintegrationsdashboardsprogramRevenueviewsindexJs,
        app: 'crm',
        type: CrmintegrationsdashboardsprogramRevenueviewsindexJs.code,
        code: 'crm:'+CrmintegrationsdashboardsprogramRevenueviewsindexJs.code
      },
      {
        ...CrmintegrationsdashboardssubscriptionsviewsindexJs,
        app: 'crm',
        type: CrmintegrationsdashboardssubscriptionsviewsindexJs.code,
        code: 'crm:'+CrmintegrationsdashboardssubscriptionsviewsindexJs.code
      },
      {
        ...FormsintegrationsdashboardsresponsesviewsindexJs,
        app: 'forms',
        type: FormsintegrationsdashboardsresponsesviewsindexJs.code,
        code: 'forms:'+FormsintegrationsdashboardsresponsesviewsindexJs.code
      },
      {
        ...FormsintegrationsdashboardsrevenueviewsindexJs,
        app: 'forms',
        type: FormsintegrationsdashboardsrevenueviewsindexJs.code,
        code: 'forms:'+FormsintegrationsdashboardsrevenueviewsindexJs.code
      },
      {
        ...MahaintegrationsdashboardsaffiliateAnnualRecurringRevenueviewsindexJs,
        app: 'maha',
        type: MahaintegrationsdashboardsaffiliateAnnualRecurringRevenueviewsindexJs.code,
        code: 'maha:'+MahaintegrationsdashboardsaffiliateAnnualRecurringRevenueviewsindexJs.code
      },
      {
        ...MahaintegrationsdashboardsaffiliateCancellationsviewsindexJs,
        app: 'maha',
        type: MahaintegrationsdashboardsaffiliateCancellationsviewsindexJs.code,
        code: 'maha:'+MahaintegrationsdashboardsaffiliateCancellationsviewsindexJs.code
      },
      {
        ...MahaintegrationsdashboardsaffiliateLifetimeRevenueviewsindexJs,
        app: 'maha',
        type: MahaintegrationsdashboardsaffiliateLifetimeRevenueviewsindexJs.code,
        code: 'maha:'+MahaintegrationsdashboardsaffiliateLifetimeRevenueviewsindexJs.code
      },
      {
        ...MahaintegrationsdashboardsaffiliateMonthlyRecurringRevenueviewsindexJs,
        app: 'maha',
        type: MahaintegrationsdashboardsaffiliateMonthlyRecurringRevenueviewsindexJs.code,
        code: 'maha:'+MahaintegrationsdashboardsaffiliateMonthlyRecurringRevenueviewsindexJs.code
      },
      {
        ...MahaintegrationsdashboardsaffiliateSignupsviewsindexJs,
        app: 'maha',
        type: MahaintegrationsdashboardsaffiliateSignupsviewsindexJs.code,
        code: 'maha:'+MahaintegrationsdashboardsaffiliateSignupsviewsindexJs.code
      },
      {
        ...MahaintegrationsdashboardsaffiliateSubscriptionsviewsindexJs,
        app: 'maha',
        type: MahaintegrationsdashboardsaffiliateSubscriptionsviewsindexJs.code,
        code: 'maha:'+MahaintegrationsdashboardsaffiliateSubscriptionsviewsindexJs.code
      },
      {
        ...MahaintegrationsdashboardsaffiliatesviewsindexJs,
        app: 'maha',
        type: MahaintegrationsdashboardsaffiliatesviewsindexJs.code,
        code: 'maha:'+MahaintegrationsdashboardsaffiliatesviewsindexJs.code
      },
      {
        ...MahaintegrationsdashboardsgreetingviewsindexJs,
        app: 'maha',
        type: MahaintegrationsdashboardsgreetingviewsindexJs.code,
        code: 'maha:'+MahaintegrationsdashboardsgreetingviewsindexJs.code
      },
      {
        ...SubscriptionsintegrationsdashboardsannualRecurringRevenueviewsindexJs,
        app: 'subscriptions',
        type: SubscriptionsintegrationsdashboardsannualRecurringRevenueviewsindexJs.code,
        code: 'subscriptions:'+SubscriptionsintegrationsdashboardsannualRecurringRevenueviewsindexJs.code
      },
      {
        ...SubscriptionsintegrationsdashboardscancellationsviewsindexJs,
        app: 'subscriptions',
        type: SubscriptionsintegrationsdashboardscancellationsviewsindexJs.code,
        code: 'subscriptions:'+SubscriptionsintegrationsdashboardscancellationsviewsindexJs.code
      },
      {
        ...SubscriptionsintegrationsdashboardsmonthlyRecurringRevenueviewsindexJs,
        app: 'subscriptions',
        type: SubscriptionsintegrationsdashboardsmonthlyRecurringRevenueviewsindexJs.code,
        code: 'subscriptions:'+SubscriptionsintegrationsdashboardsmonthlyRecurringRevenueviewsindexJs.code
      },
      {
        ...SubscriptionsintegrationsdashboardssubscriptionsviewsindexJs,
        app: 'subscriptions',
        type: SubscriptionsintegrationsdashboardssubscriptionsviewsindexJs.code,
        code: 'subscriptions:'+SubscriptionsintegrationsdashboardssubscriptionsviewsindexJs.code
      },
      {
        ...TruevailintegrationsdashboardsadvisorStartviewsindexJs,
        app: 'truevail',
        type: TruevailintegrationsdashboardsadvisorStartviewsindexJs.code,
        code: 'truevail:'+TruevailintegrationsdashboardsadvisorStartviewsindexJs.code
      },
      {
        ...TruevailintegrationsdashboardsaggregateEmailCampaignMetricviewsindexJs,
        app: 'truevail',
        type: TruevailintegrationsdashboardsaggregateEmailCampaignMetricviewsindexJs.code,
        code: 'truevail:'+TruevailintegrationsdashboardsaggregateEmailCampaignMetricviewsindexJs.code
      },
      {
        ...TruevailintegrationsdashboardsaggregateSocialCampaignMetricviewsindexJs,
        app: 'truevail',
        type: TruevailintegrationsdashboardsaggregateSocialCampaignMetricviewsindexJs.code,
        code: 'truevail:'+TruevailintegrationsdashboardsaggregateSocialCampaignMetricviewsindexJs.code
      },
      {
        ...TruevailintegrationsdashboardsrenewalPaymentsviewsindexJs,
        app: 'truevail',
        type: TruevailintegrationsdashboardsrenewalPaymentsviewsindexJs.code,
        code: 'truevail:'+TruevailintegrationsdashboardsrenewalPaymentsviewsindexJs.code
      },
      {
        ...TruevailintegrationsdashboardssignupsviewsindexJs,
        app: 'truevail',
        type: TruevailintegrationsdashboardssignupsviewsindexJs.code,
        code: 'truevail:'+TruevailintegrationsdashboardssignupsviewsindexJs.code
      },
      {
        ...TruevailintegrationsdashboardsstatusesviewsindexJs,
        app: 'truevail',
        type: TruevailintegrationsdashboardsstatusesviewsindexJs.code,
        code: 'truevail:'+TruevailintegrationsdashboardsstatusesviewsindexJs.code
      },
      {
        ...TruevailintegrationsdashboardstransitionDurationsviewsindexJs,
        app: 'truevail',
        type: TruevailintegrationsdashboardstransitionDurationsviewsindexJs.code,
        code: 'truevail:'+TruevailintegrationsdashboardstransitionDurationsviewsindexJs.code
      },
    ]
  }

  _getMaha() {
    return {
      access: this._getAccess(),
      activityCards: this._getActivityCards(),
      appUserTasks: this._getAppUserTasks(),
      appUserFields: this._getAppUserFields(),
      appUserValues: this._getAppUserValues(),
      badges: this._getBadges(),
      calendarTypes: this._getCalendarTypes(),
      dashboardCards: this._getDashboardCards(),
      roots: this._getRoots(),
      routes: this._getRoutes(),
      settings: this._getSettings(),
      triggers: this._getTriggers()  
    }
  }

  _getRoots() {
    return [
      ...mahaRoots.map(root => ({
        app: 'maha',
        component: root
      })),
      ...phoneRoots.map(root => ({
        app: 'phone',
        component: root
      })),
      ...truevailRoots.map(root => ({
        app: 'truevail',
        component: root
      })),
    ]
  }

  _getRoutes() {
    return [
      { path: '/:team/automation', children: automationRoutes },
      { path: '/:team/calendar', children: calendarRoutes },
      { path: '/:team/campaigns', children: campaignsRoutes },
      { path: '/:team/crm', children: crmRoutes },
      { path: '/:team/dashboards', children: dashboardsRoutes },
      { path: '/:team/domains', children: domainsRoutes },
      { path: '/:team/finance', children: financeRoutes },
      { path: '/:team/expenses', children: financeRoutes },
      { path: '/:team/forms', children: formsRoutes },
      { path: '/:team', children: mahaRoutes },
      { path: '/:team/phone', children: phoneRoutes },
      { path: '/:team/platform', children: platformRoutes },
      { path: '/:team/subscriptions', children: subscriptionsRoutes },
      { path: '/:team/team', children: teamRoutes },
      { path: '/:team/truevail', children: truevailRoutes },
      { path: '/:team/calendar/campaigns/email_campaigns_scheduled', component: CampaignsintegrationscalendaremailCampaignsScheduledviewsindexJs.report },
      { path: '/:team/calendar/campaigns/email_campaigns_sent', component: CampaignsintegrationscalendaremailCampaignsSentviewsindexJs.report },
      { path: '/:team/calendar/campaigns/social_campaigns_posted', component: CampaignsintegrationscalendarsocialCampaignsPostedviewsindexJs.report },
      { path: '/:team/calendar/campaigns/social_campaigns_scheduled', component: CampaignsintegrationscalendarsocialCampaignsScheduledviewsindexJs.report },
      { path: '/:team/calendar/truevail/email_campaigns_scheduled', component: TruevailintegrationscalendaremailCampaignsScheduledviewsindexJs.report },
      { path: '/:team/calendar/truevail/email_campaigns_sent', component: TruevailintegrationscalendaremailCampaignsSentviewsindexJs.report },
      { path: '/:team/dashboards/campaigns/email_campaign_metric', component: CampaignsintegrationsdashboardsemailCampaignMetricviewsindexJs.report },
      { path: '/:team/dashboards/campaigns/social_campaign_metric', component: CampaignsintegrationsdashboardssocialCampaignMetricviewsindexJs.report },
      { path: '/:team/dashboards/crm/new_contacts', component: CrmintegrationsdashboardsnewContactsviewsindexJs.report },
      { path: '/:team/dashboards/crm/program_revenue', component: CrmintegrationsdashboardsprogramRevenueviewsindexJs.report },
      { path: '/:team/dashboards/crm/subscriptions', component: CrmintegrationsdashboardssubscriptionsviewsindexJs.report },
      { path: '/:team/dashboards/forms/responses', component: FormsintegrationsdashboardsresponsesviewsindexJs.report },
      { path: '/:team/dashboards/forms/revenue', component: FormsintegrationsdashboardsrevenueviewsindexJs.report },
      { path: '/:team/dashboards/affiliate_annual_recurring_revenue', component: MahaintegrationsdashboardsaffiliateAnnualRecurringRevenueviewsindexJs.report },
      { path: '/:team/dashboards/affiliate_cancellations', component: MahaintegrationsdashboardsaffiliateCancellationsviewsindexJs.report },
      { path: '/:team/dashboards/affiliate_lifetime_revenue', component: MahaintegrationsdashboardsaffiliateLifetimeRevenueviewsindexJs.report },
      { path: '/:team/dashboards/affiliate_monthly_recurring_revenue', component: MahaintegrationsdashboardsaffiliateMonthlyRecurringRevenueviewsindexJs.report },
      { path: '/:team/dashboards/affiliate_signups', component: MahaintegrationsdashboardsaffiliateSignupsviewsindexJs.report },
      { path: '/:team/dashboards/affiliate_subscriptions', component: MahaintegrationsdashboardsaffiliateSubscriptionsviewsindexJs.report },
      { path: '/:team/dashboards/affiliates', component: MahaintegrationsdashboardsaffiliatesviewsindexJs.report },
      { path: '/:team/dashboards/greeting', component: MahaintegrationsdashboardsgreetingviewsindexJs.report },
      { path: '/:team/dashboards/subscriptions/annual_recurring_revenue', component: SubscriptionsintegrationsdashboardsannualRecurringRevenueviewsindexJs.report },
      { path: '/:team/dashboards/subscriptions/cancellations', component: SubscriptionsintegrationsdashboardscancellationsviewsindexJs.report },
      { path: '/:team/dashboards/subscriptions/monthly_recurring_revenue', component: SubscriptionsintegrationsdashboardsmonthlyRecurringRevenueviewsindexJs.report },
      { path: '/:team/dashboards/subscriptions/subscriptions', component: SubscriptionsintegrationsdashboardssubscriptionsviewsindexJs.report },
      { path: '/:team/dashboards/truevail/advisor_start', component: TruevailintegrationsdashboardsadvisorStartviewsindexJs.report },
      { path: '/:team/dashboards/truevail/aggregate_email_campaign_metric', component: TruevailintegrationsdashboardsaggregateEmailCampaignMetricviewsindexJs.report },
      { path: '/:team/dashboards/truevail/aggregate_social_campaign_metric', component: TruevailintegrationsdashboardsaggregateSocialCampaignMetricviewsindexJs.report },
      { path: '/:team/dashboards/truevail/renewal_payments', component: TruevailintegrationsdashboardsrenewalPaymentsviewsindexJs.report },
      { path: '/:team/dashboards/truevail/signups', component: TruevailintegrationsdashboardssignupsviewsindexJs.report },
      { path: '/:team/dashboards/truevail/statuses', component: TruevailintegrationsdashboardsstatusesviewsindexJs.report },
      { path: '/:team/dashboards/truevail/transition_durations', component: TruevailintegrationsdashboardstransitionDurationsviewsindexJs.report },
      { path: '/forbidden', component: Forbidden },
      { path: '/*', component: NotFound }
    ]
  }

  _getSettings() {
    return {
      crm: {
        code: 'crm',
        title: 'CRM',
        svg: 'user_round',
        fields: crmSettings
      },
      finance: {
        code: 'finance',
        title: 'Finance',
        svg: 'dollar_sign',
        fields: financeSettings
      },
      team: {
        code: 'team',
        title: 'Team',
        svg: 'users_round',
        fields: teamSettings
      },
    }
  }

  _getTriggers() {
    return [
      ...automationTriggers.map(trigger => ({
        app: 'automation',
        appTitle: 'Automation',
        svg: 'workflow',
        ...trigger
      })),
      ...calendarTriggers.map(trigger => ({
        app: 'calendar',
        appTitle: 'Calendar',
        svg: 'calendar_days',
        ...trigger
      })),
      ...campaignsTriggers.map(trigger => ({
        app: 'campaigns',
        appTitle: 'Campaigns',
        svg: 'megaphone',
        ...trigger
      })),
      ...crmTriggers.map(trigger => ({
        app: 'crm',
        appTitle: 'CRM',
        svg: 'user_round',
        ...trigger
      })),
      ...dashboardsTriggers.map(trigger => ({
        app: 'dashboards',
        appTitle: 'Dashboards',
        svg: 'layout_dashboard',
        ...trigger
      })),
      ...domainsTriggers.map(trigger => ({
        app: 'domains',
        appTitle: 'Domains',
        svg: 'globe',
        ...trigger
      })),
      ...financeTriggers.map(trigger => ({
        app: 'finance',
        appTitle: 'Finance',
        svg: 'dollar_sign',
        ...trigger
      })),
      ...formsTriggers.map(trigger => ({
        app: 'forms',
        appTitle: 'Forms',
        svg: 'square_check',
        ...trigger
      })),
      ...mahaTriggers.map(trigger => ({
        app: 'maha',
        appTitle: 'Maha',
        svg: '',
        ...trigger
      })),
      ...phoneTriggers.map(trigger => ({
        app: 'phone',
        appTitle: 'Phone',
        svg: 'phone',
        ...trigger
      })),
      ...platformTriggers.map(trigger => ({
        app: 'platform',
        appTitle: 'Platform',
        svg: '',
        ...trigger
      })),
      ...subscriptionsTriggers.map(trigger => ({
        app: 'subscriptions',
        appTitle: 'Subscriptions',
        svg: 'repeat',
        ...trigger
      })),
      ...teamTriggers.map(trigger => ({
        app: 'team',
        appTitle: 'Team',
        svg: 'users_round',
        ...trigger
      })),
      ...truevailTriggers.map(trigger => ({
        app: 'truevail',
        appTitle: 'Truevail',
        svg: 'plane',
        ...trigger
      })),
    ]
  }

}

export default hot(module)(App)
